import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Breadcrumb,
  Button,
  Checkbox,
  Container,
  Divider,
  Dropdown,
  Form,
  Grid,
  Icon,
  Input,
  Label,
  Message,
  Popup,
  Segment,
  Table,
} from 'semantic-ui-react';
import axios from 'axios';

import { useAuth, useError } from '../providers';

let options = [];
const PayPalCurrencies = {
  'AUD': {
    name: 'Australian Dollar',
    symbol: 'A$',
    fixed_fee: 0.59,
  },
  'BRL': {
    name: 'Brazilian Real',
    symbol: 'R$',
    fixed_fee: 2.90,
  },
  'CAD': {
    name: 'Canadian Dollar',
    symbol: 'C$',
    fixed_fee: 0.59,
  },
  'CZK': {
    name: 'Czech Koruna',
    symbol: 'Kč',
    fixed_fee: 9.00,
  },
  'DKK': {
    name: 'Danish Krone',
    symbol: 'Kr.',
    fixed_fee: 2.90,
  },
  'EUR': {
    name: 'Euro',
    symbol: '€',
    fixed_fee: 0.39,
  },
  'HKD': {
    name: 'Hong Kong Dollar',
    symbol: 'HK$',
    fixed_fee: 3.79,
  },
  'HUF': {
    name: 'Hungarian Forint',
    symbol: 'Ft',
    fixed_fee: 149.00,
  },
  'ILS': {
    name: 'Israeli New Shekel',
    symbol: '₪',
    fixed_fee: 1.60,
  },
  'JPY': {
    name: 'Japanese Yen',
    symbol: '¥',
    fixed_fee: 49.00,
  },
  'MYR': {
    name: 'Malaysian Ringgit',
    symbol: 'RM',
    fixed_fee: 2.00,
  },
  'MXN': {
    name: 'Mexican Peso',
    symbol: 'Mex$',
    fixed_fee: 9.00,
  },
  'NOK': {
    name: 'Norwegian Krone',
    symbol: 'kr',
    fixed_fee: 3.90,
  },
  'NZD': {
    name: 'New Zealand Dollar',
    symbol: 'NZD$',
    fixed_fee: 0.69,
  },
  'PHP': {
    name: 'Philippine Peso',
    symbol: '₱',
    fixed_fee: 25.00,
  },
  'PLN': {
    name: 'Polish Zloty',
    symbol: 'zł',
    fixed_fee: 1.89,
  },
  'GBP': {
    name: 'UK Pounds Sterling',
    symbol: '£',
    fixed_fee: 0.39,
  },
  'RUB': {
    name: 'Russian Ruble',
    symbol: '₽',
    fixed_fee: 39.00,
  },
  'SGD': {
    name: 'Signapore Dollar',
    symbol: 'S$',
    fixed_fee: 0.69,
  },
  'SEK': {
    name: 'Swedish Krona',
    symbol: 'kr',
    fixed_fee: 4.09,
  },
  'CHF': {
    name: 'Swiss Franc',
    symbol: 'CHF',
    fixed_fee: 0.49,
  },
  'TWD': {
    name: 'New Taiwan Dollar',
    symbol: 'NT$',
    fixed_fee: 14.00,
  },
  'THB': {
    name: 'Thai Baht',
    symbol: '฿',
    fixed_fee: 15.00,
  },
  'USD': {
    name: 'U.S. Dollar',
    symbol: '$',
    fixed_fee: 0.49,
  }
};

const Donations = () => {
  const [payPalEmail, setPayPalEmail] = useState(null);
  const [currency, setCurrency] = useState('USD');
  const [minimum, setMinimum] = useState(1.00);
  const [afterFees, setAfterFees] = useState(0.00)
  const [requireTwitch, setRequireTwitch] = useState(false);
  const [incentives, setIncentives] = useState([]);
  const [commands, setCommands] = useState([]);
  const { showError } = useError();
  const { user } = useAuth();

  let currencies = [];
  for (const [key, value] of Object.entries(PayPalCurrencies)) {
    currencies.push({
      key,
      text: value.name,
      value: key,
    });
  }

  let getDefaultDescription = command => {
    let found = commands.find(o => o.value === command);

    if (found && 'placeholder' in found) {
      return found.placeholder;
    }

    return 'Select an action to see the default command description, or enter your own here.'
  }


  useEffect(() => {
    const getConfig = async () => {
      try {
        const { data } = await axios(
          `/api/donations/config`,
        );
        if (data.status === 200) {
          setPayPalEmail(data.response.paypal_email);
          setCurrency(data.response.currency);
          setMinimum(parseFloat(data.response.minimum).toFixed(2));
          setRequireTwitch(data.response.twitch_required);

          const list = data.response.incentives.map(o => ({ ...o, minimum: parseFloat(o.minimum).toFixed(2) }));

          //setIncentives(data.response.incentives);
          setIncentives(list);
        }
      } catch (err) {
        showError(<center>Oops, something went wrong. Don't worry, we've been notified of the issue and will fix it as soon as possible!</center>);
      }
    }

    const getCommands = async (user) => {
      try {
        const { data } = await axios(
          `/api/donations/commands`,
        );
        if (data.status === 200) {
          let global = data.response.commands.filter((item) => {
            return item.source === 'global'
          })
          let custom = data.response.commands.filter((item) => {
            return item.source === 'custom'
          });

          if (custom.length) {
            options.push({
              key: 'header',
              children: () => <Dropdown.Header content="Custom Commands" />,
              disabled: true,
            })

            custom.forEach((command) => {
              options.push({
                key: command.command_name,
                value: command.command_name,
                text: command.command_name,
                placeholder: command.description,
              });
            });
          }

          if (global.length) {
            options.push({
              key: 'header',
              children: () => <Dropdown.Header content="Global Commands" />,
              disabled: true,
            })

            global.forEach((command) => {
              options.push({
                key: command.command_name,
                value: command.command_name,
                text: command.command_name,
                placeholder: command.description,
              });
            });
          }
          setCommands(options);
        }
      } catch (err) {
        showError(<center>Oops, something went wrong. Don't worry, we've been notified of the issue and will fix it as soon as possible!</center>);
      }
    }

    if (user['username']) {
      getCommands();
      getConfig();
    }
  }, [user, showError]);

  useEffect(() => {
    let total = Number(minimum);
    const fee = ((total * 3.49) / 100) + PayPalCurrencies[currency].fixed_fee;
    setAfterFees((total - fee).toFixed(2));
  }, [minimum, currency]);

  const updateIncentives = (index, field, value) => (ev, data) => {
    let list = [...incentives];

    console.log(index, field, value, ev, data)

    list[index][field || data['data-field']] = value || data.value;
    setIncentives(list);
  }

  const deleteIncentive = index => (ev, data) => {
    let list = [...incentives];
    let spliced = list.slice(0, index).concat(list.slice(index + 1, list.length))
    setIncentives(spliced)
  }

  const addNewIncentive = index => (ev, data) => {
    let list = [...incentives];
    list.splice(index + 1, 0, {
      minimum,
      command: null,
      command_params: null,
      description: null,
      enabled: true,
    })
    setIncentives(list);
  }

  const saveChanges = async (ev, data) => {
    let payload = {
      payPalEmail,
      currency,
      minimum,
      requireTwitch,
      incentives,
    }
    console.log(payload)

    try {
      const { data } = await axios.post(
        '/api/donations/config',
        payload,
      );

      switch (data.status) {
        case 200: // Save was successful.
          window.location.assign("/dashboard");
          break;
        case 403: // Validation error
          showError(<center>
            <p>{data.response.message}</p>
            {Object.keys(data.response.errors).map(key =>
              <p>{data.response.errors[key]}</p>
            )}
          </center>);
          break;
        case 401: // Unauthorized; redirect to home.
          showError(<center>Unauthorized access.</center>, () => window.location.assign('/'));
          break;
        case 404: // Command not found
          showError(<center>{data.response.message}</center>, () => window.location.assign('/'));
          break;
        case 500: // Internal server
        default:  // Anything else
          showError(<center>An unknown error occured while trying to save your changes.</center>);
          break;
      }
    } catch (err) {
      showError(<center>An unknown error occured while trying to save your changes.</center>);
    }
  }

  return (
    <Segment className='lobby' inverted>
      <Container text className='description'>
        <Breadcrumb size='huge'>
          <Breadcrumb.Section link as={Link} to='/dashboard'>Dashboard</Breadcrumb.Section>
          <Breadcrumb.Divider icon='right chevron' />
          <Breadcrumb.Section active>Donations</Breadcrumb.Section>
        </Breadcrumb>
        <Divider hidden />
        <p>
          Accept donations directly to your PayPal account, and add incentives tied to Twitching of Isaac when you are in-game. All payments are sent directly to your PayPal account. You can accept donations even when
          you are not using Twitching of Isaac; any donation incentives you configure will only show on the donation page when you are in-game with the Twitching of Isaac.
        </p>
        <Grid>
          <Grid.Row>
            <Grid.Column width={5}>
              Your Donations Page
            </Grid.Column>
            <Grid.Column width={11}>
              <a target='_blank' rel='noreferrer' href={`https://${window.location.hostname}/tip/${user['username']}`}>{`https://${window.location.hostname}/tip/${user['username']}`}</a>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={5}>
              PayPal Email
              &nbsp;<Popup content="Your PayPal accounts email address." position='right center' trigger={<Icon size='small' color='grey' name='help circle' />} />
            </Grid.Column>
            <Grid.Column width={11}>
              <Input
                fluid
                type='email'
                placeholder='your.paypal@example.com'
                value={payPalEmail}
                onChange={(ev) => setPayPalEmail(ev.target.value)}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={5}>
              Currency
            </Grid.Column>
            <Grid.Column width={11}>
              <Dropdown
                fluid
                selection
                options={currencies}
                defaultValue='USD'
                value={currency}
                onChange={(ev, { value }) => setCurrency(value)}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={5}>
              Minimum Amount
              &nbsp;<Popup content="The minimum amount that can be donated." position='right center' trigger={<Icon size='small' color='grey' name='help circle' />} />
            </Grid.Column>
            <Grid.Column width={11}>
              <Input
                fluid
                type='number'
                min={1.0}
                label={PayPalCurrencies[currency].symbol}
                value={minimum}
                onChange={(ev) => setMinimum(ev.target.value)}
                onBlur={(ev) => setMinimum(parseFloat(ev.target.value).toFixed(2))}
              />
              <Message size='mini' info>
                <Message.Header>PayPal Fees</Message.Header>
                <p>
                  PayPal charges you a fee for every transaction. The fee is <strong>3.49% + {PayPalCurrencies[currency].symbol}{PayPalCurrencies[currency].fixed_fee}</strong>
                  {' '}per transaction for your selected currency. Based on your minimum amount, you would receive <strong>{PayPalCurrencies[currency].symbol}{afterFees}</strong> after PayPal takes their fee.
                </p>
              </Message>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={5}>
              Require Twitch Authentication
              &nbsp;<Popup content="Require users to authenticate via Twitch to donate. May help with fraud and chargebacks." position='right center' trigger={<Icon size='small' color='grey' name='help circle' />} />
            </Grid.Column>
            <Grid.Column width={11}>
              <Checkbox
                toggle
                checked={requireTwitch}
                onChange={(ev, { checked }) => setRequireTwitch(checked)}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={5}>
              Incentives
              &nbsp;<Popup content="Donation goal incentives will only show on the donation page when you are online with the mod." position='right center' trigger={<Icon size='small' color='grey' name='help circle' />} />
            </Grid.Column>
            <Grid.Column width={11}>
              {Object.values(incentives).map((item, index) => {
                if (item && item.enabled) {
                  return (
                    <React.Fragment>
                      <Table celled compact definition inverted>
                        <Table.Body>
                          <Table.Row key={index}>
                            <Table.Cell style={{ "position": "relative" }}>
                              <Link onClick={deleteIncentive(index)}><Label floating className='noMargin' color='grey' icon='x' /></Link>
                              <Form inverted>
                                <Form.Group widths='equal'>
                                  <Form.Field>
                                    <label>
                                      Minimum Donation
                                      &nbsp;
                                      <Popup
                                        content="The minimum donation amount necessary to unlock this incentive."
                                        position='right center'
                                        trigger={<Icon size='small' color='grey' name='help circle' />}
                                      />
                                    </label>
                                    <Input
                                      fluid
                                      type='number'
                                      min={1.0}
                                      data-field='minimum'
                                      data-index={index}
                                      label={PayPalCurrencies[currency].symbol}
                                      value={item.minimum}
                                      onChange={updateIncentives(index)}
                                      onBlur={updateIncentives(index, 'minimum', parseFloat(item.minimum).toFixed(2))}
                                    />
                                  </Form.Field>
                                  <Form.Field>
                                    <label>
                                      Action
                                      &nbsp;
                                      <Popup
                                        content="The action that should be executed when this incentive is triggered by a donation. This can be global or user created commands. Incentives can trigger disabled commands, and will ignore rate limits and ban lists. Incentives will be triggered as if the user is a subscriber."
                                        position='right center'
                                        trigger={<Icon size='small' color='grey' name='help circle' />}
                                      />
                                    </label>
                                    <Dropdown
                                      selection
                                      options={commands}
                                      value={item.command}
                                      data-field='command'
                                      data-index={index}
                                      onChange={updateIncentives(index)}
                                      placeholder='Select an Action'
                                    />
                                  </Form.Field>
                                  <Form.Field>
                                    <label>
                                      Action Parameters (optional)
                                      &nbsp;
                                      <Popup
                                        content='Optional parameters to pass to the command, as if it were typed in chat; example: "!give brimstone" would expect "brimstone" to be entered in this field.'
                                        position='right center'
                                        trigger={<Icon size='small' color='grey' name='help circle' />}
                                      />
                                    </label>
                                    <Input
                                      fluid
                                      value={item.command_params}
                                      data-field='command_params'
                                      date-index={index}
                                      onChange={updateIncentives(index)}
                                    />
                                  </Form.Field>
                                </Form.Group>
                                <Form.Field>
                                  <label>Incentive Description</label>
                                  <Input
                                    fluid
                                    data-field='description'
                                    data-index={index}
                                    placeholder={getDefaultDescription(item.command)}
                                    value={item.description || null}
                                    onChange={updateIncentives(index)}
                                  />
                                </Form.Field>
                              </Form>
                            </Table.Cell>
                          </Table.Row>
                        </Table.Body>
                      </Table>
                      <Divider horizontal>
                        <Icon
                          inverted
                          name='plus square'
                          onClick={addNewIncentive(index)}
                          style={{ cursor: 'pointer' }}
                        />
                      </Divider>
                    </React.Fragment>
                  )
                } else return ''
              })}
              {(!incentives.filter((item) => item.enabled).length) ?
                <p>
                  You don't have any incentives configured yet. <Link onClick={addNewIncentive(-1)}>Click here</Link> to add one!
                </p>
                : ''}
              <center>
                <Button
                  color='violet'
                  content='Save Changes'
                  onClick={saveChanges}
                />
              </center>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    </Segment>
  )
};

export default Donations;
